import { render } from "./StatusesListShowModal.vue?vue&type=template&id=6a21310c"
import script from "./StatusesListShowModal.vue?vue&type=script&lang=js"
export * from "./StatusesListShowModal.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__